import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { PreviewIcon, EditIcon } from '../Icons/Icons';
import type { DraggableProductCardProps } from '../../types/evaluation';

export const DraggableProductCard: React.FC<DraggableProductCardProps> = ({ id, product, isPlaced, onPreview, onDoubleClick, position, rank }) => {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? 'none' : transition, // ドラッグ中はトランジションを無効化
    opacity: isDragging ? 0.8 : 1,
    cursor: isDragging ? 'grabbing' : 'grab',
  };  const handlePreviewClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if ((product.link || product.reviewLink) && onPreview) {
      onPreview(product.link || product.reviewLink || '', product.title || product.reviewTitle, id);
    }
  };

  const handleDoubleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onDoubleClick) {
      onDoubleClick(id);
    }
  };
  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`product-card ${isPlaced ? 'product-card--placed' : ''} ${isDragging ? 'product-card--dragging' : ''}`}
      onDoubleClick={handleDoubleClick}
    >
      <div className="product-card__header">
        <h3 className="product-card__title" title={product.title || product.reviewTitle}>
          {product.title || product.reviewTitle}
        </h3>
        <div className="product-card__actions">
          {(product.link || product.reviewLink) && (
            <button
              className="icon-button icon-button--sm"
              onClick={handlePreviewClick}
              title={t('draggableProductCard.showPreview')}
              aria-label={t('draggableProductCard.showPreview')}
            >
              <PreviewIcon />
            </button>
          )}
          <button
            className="icon-button icon-button--sm"
            onClick={handleDoubleClick}
            title={t('draggableProductCard.editDetails')}
            aria-label={t('draggableProductCard.editDetails')}
          >
            <EditIcon />
          </button>
        </div>
      </div>
    </div>
  );
};